import React, { useEffect } from 'react';
import { Provider, useSelector } from 'react-redux';
import { store } from './store/store';
import TabNavigation from 'components/TabNavigation';
import AirFlow from 'components/Air/AirFlow';
import LandFlow from 'components/Land/LandFlow';
import OceanFlow from 'components/Ocean/OceanFlow';
import RailFlow from 'components/Rail/RailFlow';
import DomesticFlow from 'components/Domestic/DomesticFlow';
import 'rsuite/Cascader/styles/index.css';
import './App.css';
import { useJsApiLoader } from '@react-google-maps/api';
import { useTranslation } from "react-i18next";



const RenderStepForm = ({ guestForm, initialValues }) => {
  const activeFlow = useSelector((state) => state.flow.activeFlow);
  const currentStep = useSelector((state) => state.flow.currentStep);

  const urlParams = new URLSearchParams(window.location.search);
  const isRedirected = urlParams.has('redirected');

  useEffect(() => {
    if (guestForm && currentStep && !isRedirected) {
      const currentDomain = window.location.origin;
      window.location.href = `${currentDomain}/get-quote?redirected=true`;

    }

  }, [currentStep, guestForm]);

  if (!guestForm) {
    switch (activeFlow) {
      case 'land':
        return <LandFlow step={currentStep} initialValues={initialValues} />;
      case 'air':
        return <AirFlow step={currentStep} initialValues={initialValues} />;
      case 'ocean':
        return <OceanFlow step={currentStep} initialValues={initialValues} />;
      case 'rail':
        return <RailFlow step={currentStep} initialValues={initialValues} />;
      case 'domestic':
        return <DomesticFlow step={currentStep} initialValues={initialValues} />;
      default:
        return <TabNavigation />;
    }
  } else {
    return <TabNavigation />;
  }

};

const App = ({ guestForm, initialValues }) => {
  const { t, i18n } = useTranslation();

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY ,
    libraries: ['places'],
  });

  useEffect(() => {
    const currentLang = document.documentElement.lang || "en_GB";
    i18n.changeLanguage(currentLang);
  }, [i18n]);


  return (
    <Provider store={store}>
        {isLoaded ? <RenderStepForm guestForm={guestForm} initialValues={initialValues} />: null}
    </Provider>
  );

};


export default App;